module.exports = __webpack_public_path__ + "static/media/fly0277.5be612c4.webp";